<template>
  <div class="container" :style="{'background-image': 'url('+loginbg+')'}">
    <div class="forms-container">
      <div class="signin-signup">
        <form action="" class="sign-up-form">
          <h2 class="title">忘记密码</h2>
          <div class="input-field">
            <i class="fa fa-phone"></i>
            <input type="text" v-model="registerUserForm.userPhone" placeholder="注册手机号">
          </div>
          <div class="input-field">
            <i class="fa fa-phone"></i>
            <div class="verify-input">
              <input type="text" v-model="registerUserForm.verifyCode" placeholder="验证码" style="width: 65%;">
              <div style="margin: auto 0;">
                <el-button id="verifyCode" size="small" type="primary" @click="queryVerifyCode" class="code-input" :disabled="isAreadSend"><span v-show="isAreadSend">{{ timeCount }}</span><span v-show="!isAreadSend">获取验证码</span>
                </el-button>
              </div>
            </div>
          </div>
          <div class="input-field">
            <i class="fa fa-lock"></i>
            <input type="password" v-model="registerUserForm.userPassword" placeholder="密码">
          </div>
          <div class="input-field">
            <i class="fa fa-lock"></i>
            <input type="password" v-model="registerUserForm.conformPassword" placeholder="确认密码">
          </div>
          <div v-show="registerUserForm.errorVisible" style="color: #cccccc">
            {{ registerUserForm.errorMsg }}
          </div>
          <input type="button" @click="userRegister" value="确认" class="btn solid">
          <el-row type="flex" justify="end" style="max-width: 300px;width: 100%;">
            <el-col :span="24" style="text-align: right">
              <el-button type="text" @click="goToRegister">立即登录</el-button>
            </el-col>
          </el-row>
        </form>
      </div>
    </div>
    <el-dialog
        title="修改成功"
        :visible.sync="registDialogVisible"
        width="30%"
        center>
      <span>修改密码成功， 请选择对应客户端登录</span>
      <span slot="footer" class="dialog-footer">
         <el-button @click="registDialogVisible = false">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {querySmsTime, resetPassword, sendSmsForgetPwd, sendSmsGetCode} from "../api/system/sys_user";
import {isStrEmpty} from "../lib/utils";
import {queryLoginBackgroundImage} from "../api/b2cbusiness/b2c_websetting";

export default {
  name: "ForgetPassword",
  data() {
    return {
      isAreadSend: false,
      registDialogVisible: false,
      registerUserForm: {
        userPassword: "",
        conformPassword: "",
        userPhone: "",
        errorMsg: "",
        errorVisible: false
      },
      timeCount: 300,
      loginbg: require('@/assets/img/bglogin.jpeg'),
    }
  },
  mounted() {
    const container = document.querySelector(".container");

    container.classList.add("sign-up-mode");

    querySmsTime().then(res => {
      if (res.success) {
        this.timeCount = res.data;
      }
    });
  },
  methods: {
    userRegister() {
      if (this.registerUserForm.userPassword !== this.registerUserForm.conformPassword) {
        this.registerUserForm.errorMsg = "两次输入密码不一致！"
        this.registerUserForm.errorVisible = true;
      } else {
        if (window.location.hostname == "admin.usmartdoc.com"){
          this.roleCode = "admin";
        }else if (window.location.pathname == "/salesman" || window.location.hostname=="dl.usmartdoc.com"){
          this.roleCode = "salesman"
        }else{
          this.roleCode = "business"
        }
        this.registerUserForm.roleCode = this.roleCode;
        resetPassword(this.registerUserForm).then(res => {
          if (res.success) {
            this.$message.success("修改成功")
            this.$router.push({name: 'login'});
          }
        });
      }
    },
    goToRegister() {
      this.$router.push({name: 'login'});
    },
    queryVerifyCode() {
      if (isStrEmpty(this.registerUserForm.userPhone)) {
        this.registerUserForm.errorMsg = "请输入手机号！"
        this.registerUserForm.errorVisible = true;
      } else {
        this.registerUserForm.errorVisible = false;
        let that = this;
        let t;
        sendSmsForgetPwd(this.registerUserForm.userPhone).then(res => {
          if (res.success) {
            this.$message.success("短信发送成功");
            //let timeCount1 = that.timeCount;
            //let val = document.getElementById("verifyCode");
            this.isAreadSend = true;
            t = setInterval(() => {
              if (that.timeCount > 0) {
                --that.timeCount;
                //val.value = timeCount1;
              } else {
                val.value = "获取验证码";
                that.timeCount = 300
                this.isAreadSend = false;
                clearInterval(t);
              }
            }, 1000);
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
          clearInterval(t);
        });
      }
    }
  },
  beforeRouteEnter(to, from, next){
    next(vm => {
      queryLoginBackgroundImage(window.location.hostname).then(res=>{
        if (res.success && res.data != null){
          vm.videoBgSwitch = false;
          vm.loginbg = res.data;
          vm.$forceUpdate();
        }else{
          vm.loginbg = require('@/assets/img/bglogin.jpeg');
        }
      });
    })
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
/* google字体库 */
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
}

.container::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  /*
  border-radius: 50%;
  background: linear-gradient(-45deg, #4481eb, #04befe);
  top: -10%;
  right: 48%;
  transform: translateY(-50%);
  */
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, .3);
  z-index: 4;
  transition: 1.8s ease-in-out;
}

.forms-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

}

.signin-signup {
  position: absolute;
  top: 50%;
  left: 75%;
  /* 作用是什么 */
  transform: translate(-50%, -50%);
  width: 50%;
  display: grid;
  grid-template-columns: 1fr;
  z-index: 6;
  transition: 1s 0.7s ease-in-out;
}

form {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 5rem;
  overflow: hidden;
  /* 难点 */
  grid-column: 1 / 2;
  grid-row: 1 / 2;

  /* delay防止表单提前暴露 */
  transition: 0.2s 0.7s ease-in-out;
}

form.sign-in-form {
  z-index: 2;
}

form.sign-up-form {
  z-index: 1;
  opacity: 0;
}

.verify-input {
  display: inline-grid;
  grid-template-columns: repeat(2, auto);;

  .code-input {
    position: relative;
    height: 2.3rem;
    padding: 0 6px;
    border-radius: 0;
  }
}

.title {
  font-size: 2.2rem;
  color: #FFFFFF;
  margin-bottom: 10px;
}

.input-field {
  max-width: 300px;
  width: 100%;
  height: 55px;
  background-color: #f0f0f0;
  margin: 10px 0;
  border-radius: 0px;
  display: grid;
  grid-template-columns: 15% 85%;
  padding: 0 .4rem;
}

.input-field select {
  background: none;
  outline: none;
  border: none;
  line-height: 1;
  font-weight: 600;
  font-size: 1.1rem;
  color: #aaa;
}

.input-field i {
  text-align: center;
  line-height: 55px;
  color: #acacac;
  font-size: 1.1rem;
}

.input-field input {
  background: none;
  outline: none;
  border: none;
  line-height: 1;
  font-weight: 600;
  font-size: 1.1rem;
  color: #333;
}

.input-field input::placeholder {
  color: #aaa;
  font-weight: 500;
}

.btn {
  width: 300px;
  height: 40px;
  border: none;
  outline: none;
  border-radius: 0px;
  cursor: pointer;
  background-color: #5995fd;
  color: #fff;
  /* 大写 */
  text-transform: uppercase;
  font-weight: 600;
  margin: 10px 0;
  /* 动画延迟 */
  transition: .5s;
}

.btn:hover {
  background-color: #4d84e2;
}

.social-text {
  padding: .7rem 0;
  font-size: 1rem;
}

.social-media {
  display: flex;
  justify-content: center;
}

.social-icon {
  height: 40px;
  width: 40px;
  border: 1px solid #333;
  margin: 0 0.45rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: #333;
  font-size: 1.1rem;
  border-radius: 50%;
  transition: 0.3s;
}

.social-icon:hover {
  color: #4481eb;
  border-color: #44b1eb;
}

.panels-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.panel {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: center;
  justify-content: center;
  z-index: 7;
}

.panel .content {
  color: #fff;
  transition: .9s .6s ease-in-out;
}

.panel h3 {
  font-weight: 600;
  line-height: 1;
  font-size: 1.5rem;
}

.panel p {
  font-size: 0.95rem;
  padding: 0.7rem 0;
}

.btn.transparent {
  margin: 0;
  background: none;
  border: 2px solid #fff;
  width: 130px;
  height: 41px;
  font-weight: 600;
  font-size: 0.8rem;
}

.left-panel {
  pointer-events: all;
  padding: 3rem 17% 2rem 12%;
}

.right-panel {
  pointer-events: none;
  padding: 3rem 12% 2rem 17%;
}

.image {
  width: 100%;
  transition: 1.1s .4s ease-in-out;
}

.right-panel .content, .right-panel .image {
  transform: translateX(800px);
}

.container.sign-up-mode:before {
  /* transform: translate(100%, -50%);
   right: 52%;

   */
}

.container.sign-up-mode .left-panel .image,
.container.sign-up-mode .left-panel .content {
  transform: translateX(-800px);
}

.container.sign-up-mode .right-panel .content,
.container.sign-up-mode .right-panel .image {
  transform: translateX(0px);
}

.container.sign-up-mode .left-panel {
  pointer-events: none;
}

.container.sign-up-mode .right-panel {
  pointer-events: all;
}

.container.sign-up-mode .signin-signup {
  /*left: 25%;*/
}

.container.sign-up-mode form.sign-in-form {
  z-index: 1;
  opacity: 0;
}

.container.sign-up-mode form.sign-up-form {
  z-index: 2;
  opacity: 1;
}

@media(max-width: 870px) {
  .container {
    min-height: 800px;
    height: 100vh;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .container:before {
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  .signin-signup {
    width: 100%;
  }

  .panels-container {

    z-index: 10;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 2fr 1fr;
  }

  .panel {
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 2.5rem 8%;
  }

  .verify-input {
    display: inline-flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .code-input {
      font-size: 1rem;
      color: #44b1eb;
      position: relative;
      right: 30%;
      text-align: right;
    }
  }

  .image {
    width: 200px;
    transition: 0.9s 0.6s ease-in-out;
  }

  .left-panel {
    grid-row: 1 / 2;
  }

  .right-panel {
    grid-row: 3 / 4;
  }

  .panel h3 {
    font-size: 1.2rem;
  }

  .panel p {
    font-size: 0.7rem;
    padding: 0.5rem 0;
  }

  .btn.btn.transparent {
    width: 110px;
    height: 35px;
    font-variation-settings: 0.7rem;
  }

  .panel .content {
    padding-right: 15%;
    transition: 0.9s 0.8s ease-in-out;
  }

  .right-panel .content, .right-panel .image {
    transform: translateY(300px);
  }

  .container.sign-up-mode:before {
    transform: translate(-50%, 100%);
    bottom: 32%;
    right: initial;
  }

  .container.sign-up-mode .left-panel .image,
  .container.sign-up-mode .left-panel .content {
    transform: translateY(-300px);
  }

  .container.sign-up-mode .signin-signup {
    top: 5%;
    transform: translate(-50%, 0);
    left: 50%;
  }
}

@media (max-width: 465px) {
  form {
    padding: 0 1.5rem;
  }

  .image {
    display: none;
  }

  .container .left-panel .content,
  .container .right-panel .content {
    margin-left: 40px;
  }

}
</style>
